import { FetchTransport, faro, getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { useEffect } from 'react';
import { useAuth } from 'src/auth';
import { dropIgnoredResourceTimings } from 'src/lib/faroBeforeSend';

let FARO_ENABLED = false;

const collectionId = {
  local: '7833ee07ef1fd4f6478eb532ab6d9ad0',
  integration: 'e526a164f6d28e1502d15cca22ca976e',
  staging: 'd49ab561151fcff9b3f1df08c10f3803',
  production: 'f7a7057dcb3da9ddb1d34940054b997b',
};

if (process.env.NODE_ENV === 'production') {
  initializeFaro({
    app: {
      name: `agriful-web-${process.env.AGRIFUL_ENV}`,
      version: process.env.RENDER_GIT_COMMIT,
      environment: process.env.AGRIFUL_ENV,
    },
    trackGeolocation: false,
    beforeSend: dropIgnoredResourceTimings,
    instrumentations: [
      ...getWebInstrumentations({ captureConsole: true }),
      new TracingInstrumentation({
        instrumentationOptions: {
          // Propagate W3C traceparent header to the API so backend spans
          // are linked to frontend traces in Grafana.
          // Scoped to the api subdomain — Clerk's CORS rejects unknown
          // request headers and a broader regex blocks browser sign-in.
          propagateTraceHeaderCorsUrls: [/api(?:-[a-z]+)?\.agrifulsoftware\.com/, /localhost/],
        },
      }),
    ],
    transports: [
      new FetchTransport({
        url: `https://faro-collector-prod-us-east-0.grafana.net/collect/${collectionId[process.env.AGRIFUL_ENV]}`,
        bufferSize: 60, // default is 30
      }),
    ],
  });
  FARO_ENABLED = true;
}

interface FaroOrg {
  id?: string;
  name?: string;
}

export function useIdentifyFaroUser(organization?: FaroOrg | null) {
  const { currentUser } = useAuth();

  useEffect(() => {
    // Set user context for RUM
    if (FARO_ENABLED) {
      if (currentUser) {
        faro.api.setUser({
          id: currentUser.id as string, // Clerk ID
          email: currentUser.emailAddress instanceof Array ? currentUser.emailAddress[0] : currentUser.emailAddress,
          attributes: {
            name: `${currentUser.firstName} ${currentUser.lastName}`,
            ...(organization?.name && { orgName: organization.name }),
            ...(organization?.id && { clerkOrgId: organization.id }),
          },
        });
      } else {
        // Clear user's context if user logs out
        faro.api.resetUser();
      }
    }
  }, [currentUser, organization?.id]);
}
